import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import EditorialMarquee from "@/components/site/Marquee";
import Manifesto from "@/components/site/Manifesto";
import Catalog from "@/components/site/Catalog";
import Reviews from "@/components/site/Reviews";
import Footer from "@/components/site/Footer";
import { getWhatsappNumber } from "@/lib/api";

export default function Home() {
  useEffect(() => {
    getWhatsappNumber();
  }, []);

  return (
    <main className="bg-[#0C0A09]" data-testid="home-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <Manifesto />
      <Catalog />
      <Reviews />
      <Footer />
    </main>
  );
}
